import React from 'react';
import useStartCheckin from './StartCheckin.hook';
import Page from '../../shared/layouts/Page';
import StartCheckinPage from './StartCheckinPage';
import BookingSearchLoader from '../BookingSearchLoader/BookingSearchLoader';
import BookingNotFound from '../BookingNotFound/BookingNotFound';

export default function StartCheckin() {
  const { state, actions } = useStartCheckin();
  return (
    <Page backButton={!state.loading} showShareButton={true} showLogoutButton={false}>
      {state.loading ? (
        <BookingSearchLoader></BookingSearchLoader>
      ) : state.checkinRequirements ? (
        <>
          <StartCheckinPage state={state} actions={actions}></StartCheckinPage>
        </>
      ) : (
        <BookingNotFound pmsMessage={state.pmsMessage} />
      )}
    </Page>
  );
}
